// extracted by mini-css-extract-plugin
export default {"mobile":"(max-width: 360px)","mediumMobile":"(max-width: 480px)","smallDesktop":"(max-width: 1020px)","backgroundWrapper":"Background_backgroundWrapper__-29I3"};